import React from 'react';
import {
  AccountSwitcherType,
  AccountSwitchTrigger,
} from '../../../flows/profile/components/switch-trigger/AccountSwitchTrigger';
import { ISummaryData } from '../../../types';
import { useStore } from '../../../store';

export const AccountSwitcherBlock = () => {
  const summaryData: ISummaryData = useStore((state) => state.summary);
  const isAuthorizedUser = summaryData?.authorizedUserType !== undefined;
  return (
    <AccountSwitchTrigger
      onCloseDetails={() => {}}
      switcherType={isAuthorizedUser ? AccountSwitcherType.AUTHORIZED_USER : AccountSwitcherType.BUSINESS}
    />
  );
};
